(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_common/banner-helpers/assets/javascripts/jackpots.js') >= 0) return;  svs.modules.push('/components/banner_common/banner-helpers/assets/javascripts/jackpots.js');

'use strict';

let currencyInMillions;
let productMapping;
let getNumbergamesJackpot;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  currencyInMillions = trinidad.components.require('utils', 'format').api.CurrencyInMillions;
  productMapping = trinidad.components.require('numbergames', 'product-mapping').productMapping;
  getNumbergamesJackpot = trinidad.components.require('numbergames', 'jackpots').getJackpot;
} else {
  currencyInMillions = svs.utils.format.CurrencyInMillions;
  productMapping = svs.numbergames.productMapping;
  getNumbergamesJackpot = svs.numbergames.draws.jackpotApi.jackpot;
}

function formatRubbetJackpot(jackpots) {
  if (!jackpots) {
    return {};
  }
  const totalJackpotAmount = productMapping.getAllNumericIds().reduce((sum, id) => {
    const jackpot = getNumbergamesJackpot({
      product: id,
      jackpots: JSON.parse(JSON.stringify(jackpots))
    });
    if (!jackpot) return sum;
    return sum + parseInt(jackpot.jackpotAmount, 10);
  }, 0);
  return {
    jackpotLabel: 'Totala toppvinster',
    description: 'Rubbet',
    jackpotString: "ca ".concat(currencyInMillions(totalJackpotAmount), " milj kr")
  };
}

function handleFivePlusOneJackpot(jackpots, filteredJackpotList) {
  if (filteredJackpotList.length >= 2) {
    const eurojackpotIndex = filteredJackpotList.findIndex(jackpot => jackpot.description === 'Eurojackpot');
    const fivePlusOneJackpot = jackpots.find(jackpot => jackpot.description === 'Eurojackpot 5+1');
    if (eurojackpotIndex !== -1 && fivePlusOneJackpot) {
      filteredJackpotList[eurojackpotIndex].secondaryJackpotAmount = fivePlusOneJackpot.jackpotAmount;
    }
  }
}
function getJackpotLabel(description, defaultJackpot) {
  const isDreamWin = description === 'Drömvinsten';
  const wordForJackpotInLabel = isDreamWin ? description : 'Jackpot';
  const alwaysWording = isDreamWin ? 'alltid' : 'alltid minst';
  return defaultJackpot ? "".concat(wordForJackpotInLabel, " ").concat(alwaysWording) : "".concat(wordForJackpotInLabel, " just nu");
}

function formatJackpot(_ref) {
  let product = _ref.product,
    jackpots = _ref.jackpots;
  if (product === 'rubbet') {
    return formatRubbetJackpot(jackpots);
  }
  const filteredJackpotList = jackpots.filter(jackpot => {
    const lowerCaseProductName = jackpot.productName.toLowerCase();
    const productMatch = lowerCaseProductName === product.toLowerCase();
    if (!productMatch) return false;
    if (lowerCaseProductName === 'lotto') {
      return jackpot.description === 'Drömvinsten';
    }
    return true;
  });
  if (product.toLowerCase() === 'eurojackpot') {
    handleFivePlusOneJackpot(jackpots, filteredJackpotList);
  }
  const _ref2 = filteredJackpotList[0] || {},
    description = _ref2.description,
    defaultJackpot = _ref2.defaultJackpot,
    jackpotAmountStringShort = _ref2.jackpotAmountStringShort,
    guaranteedJackpotAmountStringShort = _ref2.guaranteedJackpotAmountStringShort,
    secondaryJackpotAmount = _ref2.secondaryJackpotAmount;
  const jackpotLabel = getJackpotLabel(description, defaultJackpot);
  const secondaryJackpotString = secondaryJackpotAmount ? "5+1 r\xE4tt ca ".concat(currencyInMillions(secondaryJackpotAmount), " milj kr") : '';

  const dreamWinJackpot = jackpots.find(jackpot => jackpot.description === 'Drömvinsten');
  if (dreamWinJackpot) {
    dreamWinJackpot.guaranteedJackpotAmountStringShort = dreamWinJackpot.guaranteedJackpotAmountStringShort.replace('ca ', '');
  }
  return {
    jackpotLabel,
    description,
    defaultJackpot,
    jackpotString: defaultJackpot ? guaranteedJackpotAmountStringShort : jackpotAmountStringShort,
    secondaryJackpotString
  };
}
if (svs.isServer) {
  module.exports = {
    formatJackpot,
    formatRubbetJackpot
  };
} else {
  svs.banner_common.banner_helpers.formatJackpot = formatJackpot;
  svs.banner_common.banner_helpers.formatRubbetJackpot = formatRubbetJackpot;
}

 })(window);